import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@sainsburys-tech/bolt';
import { Content, ProductFetch } from './components';
import { onQuickViewSlidingPanelShut, options } from './tracking';

var QuickView = function QuickView(_ref) {
  var heading = _ref.heading,
      show = _ref.show,
      position = _ref.position,
      toggleQuickView = _ref.toggleQuickView,
      selectedProductId = _ref.selectedProductId,
      overrideAddToTrolley = _ref.overrideAddToTrolley,
      overrideAddToTrolleyText = _ref.overrideAddToTrolleyText,
      overrideMaxWidth = _ref.overrideMaxWidth,
      hideVariants = _ref.hideVariants,
      trackingOptions = _ref.trackingOptions,
      availability = _ref.availability,
      _onProductChange = _ref.onProductChange,
      showReviews = _ref.showReviews,
      dataTest = _ref['data-test'],
      onFullDetailsClick = _ref.onFullDetailsClick,
      onSlideChanged = _ref.onSlideChanged;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      updatedProductId = _useState2[0],
      updateSelectedPartNumber = _useState2[1];

  var productId = updatedProductId || selectedProductId;
  var footerPortal = 'ac-quick-view__footer';

  var toggleCallback = function toggleCallback() {
    updateSelectedPartNumber(null);
    onQuickViewSlidingPanelShut(window);
    toggleQuickView();
  };

  return /*#__PURE__*/React.createElement(Drawer, {
    position: position,
    show: show,
    heading: heading,
    onClose: function onClose() {
      return toggleCallback();
    },
    footer: /*#__PURE__*/React.createElement("div", {
      id: footerPortal
    }),
    "data-test": dataTest,
    style: {
      zIndex: 89,
      maxWidth: overrideMaxWidth
    }
  }, /*#__PURE__*/React.createElement(ProductFetch, {
    fetch: show,
    partNumbers: [productId],
    render: function render(_ref2) {
      var products = _ref2.products,
          isLoading = _ref2.isLoading;
      return /*#__PURE__*/React.createElement(Content, {
        "data-test": "".concat(dataTest, "-content"),
        isLoading: isLoading,
        product: products[productId],
        toggleQuickView: toggleQuickView,
        fetchProductCallback: updateSelectedPartNumber,
        trackingOptions: trackingOptions,
        footerPortal: footerPortal,
        overrideAddToTrolley: overrideAddToTrolley,
        overrideAddToTrolleyText: overrideAddToTrolleyText,
        hideVariants: hideVariants,
        availability: availability,
        showReviews: showReviews,
        onProductChange: function onProductChange(variantProductId, variantType) {
          if (_onProductChange) _onProductChange(variantProductId, variantType);
        },
        onFullDetailsClick: onFullDetailsClick,
        onSlideChanged: onSlideChanged
      });
    }
  }));
};

QuickView.displayName = 'QuickView';
QuickView.defaultProps = {
  show: false,
  position: 'right',
  heading: '',
  toggleQuickView:
  /* istanbul ignore next */
  function toggleQuickView() {},
  onSlideChanged:
  /* istanbul ignore next */
  function onSlideChanged() {},
  trackingOptions: options,
  hideVariants: false,
  'data-test': 'component-quick-view',
  showReviews: true
};
QuickView.propTypes = {
  /**
   * Required Prop of the product Id that you want to show in the quick view
   */
  selectedProductId: PropTypes.string.isRequired,

  /**
   * Prop toggle the visibility of the quick view
   */
  show: PropTypes.bool,

  /**
   * Prop to set the position of the quick view
   */
  position: PropTypes.oneOf(['left', 'right', 'center']),

  /**
   * Prop to set the title of the quick view
   */
  heading: PropTypes.string,

  /**
   * Prop for callbacks if needed on closing or changing product id
   */
  toggleQuickView: PropTypes.func,

  /**
   * Prop shape for analytics for quick view
   */
  trackingOptions: PropTypes.shape({
    type: PropTypes.string,
    clickOrigin: PropTypes.string,
    eventName: PropTypes.string,
    queryParams: PropTypes.object
  }),

  /**
   * Optional Prop to override Add to trolley behavior
   */
  overrideAddToTrolley: PropTypes.func,

  /**
   * Optional Prop to override Add to trolley text
   */
  overrideAddToTrolleyText: PropTypes.string,

  /**
   * Optional prop to override the width of the drawer
   */
  overrideMaxWidth: PropTypes.string,

  /**
   * Optional Prop to hide the view of variant options
   */
  hideVariants: PropTypes.bool,

  /**
   * Optional Prop to show "availability pills"
   */
  availability: PropTypes.shape({
    collection: {
      available: PropTypes.bool
    },
    delivery: {
      available: PropTypes.bool
    }
  }),

  /**
   * Optional Prop to allow a callback function when a product is changed
   */
  onProductChange: PropTypes.func,

  /**
   * Optional to show/hide reviews
   */
  showReviews: PropTypes.bool,

  /**
   * Prop for setting data-test attribute for testing
   */
  'data-test': PropTypes.string,

  /**
   * Optional Prop to allow a callback function when full details is clicked
   */
  onFullDetailsClick: PropTypes.func,

  /**
   * Optional Prop to allow a callback function when image slides are changed
   */
  onSlideChanged: PropTypes.func
};
QuickView.ProductFetch = ProductFetch;
export default QuickView;